import { Box, Typography } from '@mui/material'
import MainLayout from 'layouts/mainLayout'
import React, { useState, useEffect } from 'react'
import * as api from "../api/endpoints/partnerService";
import MzDataGrid from "@markaaz/ui/MzDataGrid";
import MzInput from "@markaaz/ui/MzInputControls";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

const sx = {
  title: {
    color: "darkBlue.c100",
    marginBottom: "10px"
  },
  gridDesc: {
    color: "darkBlue.c100"
  },
  input: {
    margin: "10px 0",
    width: "600px"
  },
  datagrid: {
    maxHeight: "585px",
    maxWidth: "1200px",
    "& .MuiDataGrid-columnHeader": {
      paddingLeft: "10px"
    },
    "& .MuiDataGrid-columnHeaders": {
      borderBottom: 0
    },
    "& .MuiDataGrid-columnHeaderTitle": (theme) => {
      return { ...theme.typography.body2M };
    },
    "& .MuiDataGrid-cell": {
      paddingLeft: "10px"
    },
    "& .MuiDataGrid-cell:last-child, & .MuiDataGrid-cell:nth-last-child(2)": {
      padding: 0
    },
    "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
      borderBottom: "none"
    },
    "& .MuiDataGrid-row:last-child": {
      borderBottomLeftRadius: "8px"
    },
    "& .MuiDataGrid-virtualScroller": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        backgroundColor: (theme) => `${theme.palette.common.white}`,
        width: "5px"
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: (theme) => `${theme.palette.darkBlue.c20}`,
        borderRadius: "8px",
      }
    }
  }
};

export default function GoldenRecordsPage() {
  const [loading, setLoading] = useState(false)
  const [goldenRecords, setGoldenRecords] = useState([])
  const [filteredGoldenRecords, setFilteredGoldenRecords] = useState([])

  const columnHeaderHeight = 56;
  const columns = [
    {
      field: "bespokeGoldenRecordId",
      headerName: "Bespoke Golden Record Id",
      width: 210,
      sortable: false
    },
    {
      field: "markaazId",
      headerName: "Markaaz Id",
      width: 160,
      sortable: false
    },
    {
      field: "businessName",
      headerName: "Business Name",
      width: 140,
      sortable: false
    },
    {
      field: "businessCountry",
      headerName: "Business Country",
      width: 145,
      sortable: false
    },
    {
      field: "lastChangeDate",
      headerName: "Last Change Date",
      width: 150,
      sortable: false
    },
    {
      field: "changedBy",
      headerName: "Changed By",
      width: 140,
      sortable: false
    },
    {
      field: "valueChanged",
      headerName: "Value Changed",
      width: 250,
      sortable: false,
    },
  ];
  

  useEffect(()=>{
      setLoading(true);
      api.getBespokeGoldenRecords().then((res)=>{
        setGoldenRecords(res.data)
        setFilteredGoldenRecords(res.data)
      })
      .finally(()=>{
        setLoading(false);
      })
  }, [])

  function normalizeText(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function handleSearch(event) {
    let search = normalizeText(event.target.value);
  
    let filteredData = goldenRecords.filter(item =>
      normalizeText(item.businessName).includes(search)
    );

    setFilteredGoldenRecords(filteredData)
  }

  return (
    <MainLayout>
      <Box marginBottom="40px">
        <Typography sx={sx.title} variant="h4">Your Golden Records</Typography>
        <Typography sx={sx.gridDesc} variant="body2">
          Review the businesses in your portfolio with bespoke golden records.
        </Typography>
      </Box>
        <MzInput
          sx={sx.input}
          name="search"
          autoComplete="off"
          noBorder
          placeholder="Enter Business Name"
          onChange={handleSearch}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon fontSize="large"/>
              </InputAdornment>
            ),
          }}
        />
      <Box height="585px">
      <MzDataGrid
        columnHeaderHeight={columnHeaderHeight}
        sx={sx.datagrid}
        getRowId={(row) => row.bespokeGoldenRecordId}
        loading={loading}
        variant="3"
        rows={filteredGoldenRecords}
        columns={columns}
        getRowHeight={(params) =>
          params.model.valueChanged.length > 60 ? 90 : 75
        }
        autoHeight={false} 
        disableSelectionOnClick
        disableColumnMenu={true}
        hideFooterPagination
        hideFooter
      />
     </Box>
    </MainLayout>
  )
}